module.exports = "/images/cardImg.svg";